<template>
  <div class="page-theatre-detail">
    <details-modal-skeleton v-if="isLoading"/>
    <div v-else class="theatre-header" v-lazy:background-image="imageUrl(media.image1, true)">
      <div class="banner-layer">
        <h1 v-if="media != null">{{ media.title }}</h1>
        <div class="theather-header-content grid grid-cols-2">
          <div class="content-info col grid grid-cols-2">
            <div class="col detail-card">
              <div class="suggest-item">
                <!--                <span class="card__rate card__rate&#45;&#45;green">{{ media.rate ? media.rate : '0.0' }}</span>-->
                <img :src="Poster" v-lazy:background-image="imageUrl(media.image, true)" class="poster rounded-md"/>
              </div>

              <div v-if="user == null">
                <div class="detail-auth-btn">
                  <auth/>
                </div>
              </div>

              <div v-else-if="isLoadingAccess && user != null">
                <a href="javascript:void(0)" class="card__btn disabled">
                  <span>Түр хүлээнэ үү...</span>
                </a>
              </div>

              <div v-else-if="!isLoadingAccess && user != null">
                <router-link v-if="hasAccess && media.main_cat_id == 1" :to="`/watch/${media.id}/${media.epId}`"
                             class="card__btn">
                  <i class="isax isax-play"></i>
                  <span>Үзэх</span>
                </router-link>

                <router-link v-if="hasAccess && media.main_cat_id == 3" :to="`/theatre/watch/${media.id}`"
                             class="card__btn">
                  <i class="isax isax-play"></i>
                  <span>Үзэх</span>
                </router-link>

                <a v-if="!hasAccess && media.main_cat_id == 3" href="javascript:void(0)" @click="showTaxType"
                   class="card__btn">
                  <i class="isax isax-video-add"></i>
                  <span>Түрээслэх - {{ parseInt(media.price) }}₮</span>
                </a>

                <router-link v-if="!hasAccess && media.main_cat_id == 1" to="/payment"
                             class="card__btn">
                  <i class="isax isax-video-add"></i>
                  <span>Эрх сунгах</span>
                </router-link>
              </div>
            </div>

            <div class="col">
              <!--              <div class="space-x-2">-->
              <!--                <span class="text-gray-400">Найруулагч:</span>-->
              <!--                <span class="text-white">{{ media.director ? media.director.name : 'N/A' }}</span>-->
              <!--              </div>-->
              <!--              <div class="space-x-2">-->
              <!--                <span class="text-gray-400">Гарсан жил:</span>-->
              <!--                <span class="text-white">{{ media.released_date ? media.released_date : 'N/A' }}</span>-->
              <!--              </div>-->

<!--              <div class="space-x-2 mb-2">-->
<!--                <span class="text-gray-400">Насны ангилал:</span>-->
<!--                <router-link v-for="item in media.ages" :key="item.id" :to="`/age/${item.id}`">-->
<!--                  <Tag class="t-tag w-tag" :value="item.title"></Tag>-->
<!--                </router-link>-->
<!--              </div>-->

              <div class="space-x-2" style="display: flex; align-items:center">
                <span class="text-gray-400">Ангилал:</span>
                <router-link v-for="item in media.categories"
                             :key="item.id"
                             :to="'/series/' + item.id + '/all/all/all?t='+item.title">
                  <Tag class="t-tag" :value="item.title"></Tag>
                </router-link>
              </div>

              <div class="hidden trailer-frame mobile-trailer">
                <iframe
                    v-if="media.trailer != null"
                    width="100%"
                    height="100%"
                    :src="`//www.youtube.com/embed/${getTrailerId(media.trailer)}`"
                    frameborder="0"
                    allowfullscreen
                />
                <div v-else class="no-trailer">
                  <i class="isax isax-emoji-sad"></i>
                  <span>Трэйлер олдсонгүй</span>
                </div>
              </div>

              <!--              <div class="space-x-2">-->
              <!--                <span class="text-gray-400">Үргэлжлэх хугацаа</span>-->
              <!--                <span class="text-white">2ц 15м </span>-->
              <!--              </div>-->

              <p class="text-base txt-desc" v-html="media.description"></p>
            </div>
          </div>

          <div class="content-trailer col">
            <div class="trailer-frame">
              <iframe
                  v-if="media.trailer != null"
                  width="100%"
                  height="100%"
                  :src="`//www.youtube.com/embed/${getTrailerId(media.trailer)}`"
                  frameborder="0"
                  allowfullscreen
              />
              <div v-else class="no-trailer">
                <i class="isax isax-emoji-sad"></i>
                <span>Трэйлер олдсонгүй</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="page-theatre-detail-body">
      <div class="grid grid-cols-5 gap-10">
        <!-- Episode list-->
        <div class="col-span-3" v-if="media != null && media.main_cat_id == 1">
          <div class="episode-wrapper">
            <div class="episode-wrapper-body">
              <div class="episode-loader" v-if="media == null || isLoading">
                <!--                <ProgressSpinner/>-->
              </div>
              <div v-else>
                <episode-list :disable-search="true" :media-id="media.id" :is-list="true"
                              :seasons="media.other_seasons"/>
              </div>
            </div>
          </div>
        </div>

        <div :class="`${(media != null && media.main_cat_id == 1) ? 'col-span-2' : 'col-span-5'}`">
          <div :class="`media-characters ${(media != null && media.main_cat_id == 1) ? '' : 'horz'}`">
            <!--Director and Studio-->
            <!--            <div class="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-1 gap-4">-->
            <!--              <div class="media-characters-item">-->
            <!--                <h1 class="text-2xl mb-5">Шагналууд</h1>-->
            <!--                <div v-if="media != null && media.awards != null" class="award-list">-->
            <!--                  <div class="award-item" v-for="item in media.awards" :key="item.id">-->
            <!--                    <div class="award-img">-->
            <!--                      <img :src="`http://seeroo.mn${item.image}`" alt="award">-->
            <!--                    </div>-->
            <!--                    <span>{{ item.title }}</span>-->
            <!--                  </div>-->
            <!--                </div>-->
            <!--                <div class="no-data" v-else>-->
            <!--                  <img src="/img/not-found.png" alt="not-found">-->
            <!--                  <h3>Шагналын мэдээлэл олдсонгүй</h3>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->

            <!--            <Divider v-if="media != null && media.main_cat_id == 1"/>-->
            <!--Actors-->
            <!--            <div class="award-wrap" v-if="media != null && media.actors != null">-->
            <!--              <h1 class="text-2xl mb-5">Дүрүүд</h1>-->
            <!--              <div class="grid grid-cols-1 gap-4">-->
            <!--                <div v-if="media != null && media.characters != null" class="character-list">-->
            <!--                  <router-link :to="`/character/anime/list/${item.id}`" class="award-item"-->
            <!--                               v-for="item in media.characters" :key="item.id">-->
            <!--                    <div class="award-img">-->
            <!--                      <img :src="`http://seeroo.mn${item.image}`" alt="award">-->
            <!--                    </div>-->
            <!--                    <span>{{ item.name }}</span>-->
            <!--                  </router-link>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>

      <div class="detail-divider"></div>

      <!--Related-->
      <div v-if="media != null && media.related != null">
        <h1 class="text-2xl mb-5" style="color: white !important;">Төстэй цувралууд</h1>
        <div class="media-list">
          <div class="media-grid-wrapper">
            <div class="media-grid grid gap-4 lg:grid-cols-6 md:grid-cols-4 sm:grid-cols-2 grid-cols-2">
              <router-link :to="`/theatre/detail/${item.id}`" v-for="item in media.related" :key="item.id"
                           class="media-item">
                <figure class="effect-sadie">
                  <img :src="Poster" v-lazy:background-image="imageUrl(item.image, true)" class="poster rounded-md"/>
                  <figcaption>
                    <div class="item-actions">
                      <a v-if="item.age_limit" href="javascript:void(0)">
                        <span>{{ item.age_limit }}+</span>
                      </a>
                    </div>
                    <p style="font-weight: bold;">{{ item.title }}</p>
                    <!--                    <p v-html="item.description"></p>-->
                  </figcaption>
                </figure>
              </router-link>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>

  <Dialog v-model:visible="isTaxType" :breakpoints="{'500px': '75vw', '500px': '90vw'}" :style="{width: '440px'}"
          :modal="true">
    <div style="border:1px solid grey; border-radius: 10px; width: 360px; padding: 20px 20px; margin-bottom: 30px">
      <p style="display:flex;align-items: center; justify-content: center; font-size: 18px; color: hsla(0, 0%, 100%, .8); padding-bottom: 10px">
        Баримт авах
        төрөлөө сонгоно уу</p>
      <RadioGroup v-model="ebType"
                  style="display: flex; flex-direction: row; align-items: center; justify-content: space-between">
        <div style="border: 1px solid grey; border-radius:6px; padding:6px 20px">
          <Radio label="0">
            <span style="color: white;font-size: 16px; margin-left: 8px;">Хувь хүн</span>
          </Radio>
        </div>
        <div style="border: 1px solid grey; border-radius:6px; padding:6px 20px">
          <Radio label="1" style="padding-left: 10px">
            <span style="color: white;font-size: 16px; margin-left: 8px;">Байгууллага</span>
          </Radio>
        </div>

      </RadioGroup>
      <Input
          v-if="ebType === '1'"
          size="small"
          type="text"
          class="company-code-input"
          v-model="companyCode"
          @input="handleInputChange"
          placeholder="Байгууллагын кодоо оруулна уу"
          maxlength="10"
      />
      <p v-if="errorMessage" style="color: red; font-size: 14px; margin-top: 5px;">{{ errorMessage }}</p>
    </div>


    <a href="javascript:void(0)" @click="validateAndNavigate" class="primary-btn full" style="background: #121212">
      <span>Үргэлжлүүлэх</span>
    </a>


  </Dialog>

  <Dialog v-model:visible="eBarimtView" :breakpoints="{'500px': '75vw', '500px': '90vw'}" :style="{width: '440px'}"
          :modal="true">
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; background: black">
      <div class="qpay-success">
        <i class="isax isax-tick-circle" style="font-size: 40px !important;"></i>
        <h5 style="font-size: 14px">{{ this.resultMsg }}</h5>
      </div>
      <div class="tax-wrap">
        <div class="tax-wrap-header">
          <img src="../../assets/ebarimt.png" alt="tax" style="color:white">
        </div>

        <div class="tax-wrap-body" v-if="taxDetail != null">
          <table>
            <tr>
              <td>Огноо:</td>
              <td>{{ taxDetail.tax_dt }}</td>
            </tr>

            <tr>
              <td>ДДТД:</td>
              <td>{{ taxDetail.tax_id }}</td>
            </tr>

            <tr>
              <td>Нийт дүн:</td>
              <td>{{ new Intl.NumberFormat().format(taxDetail.tax_amount) }} ₮</td>
            </tr>

            <tr>
              <td>НӨАТ:</td>
              <td>{{ new Intl.NumberFormat().format(taxDetail.tax_vat) }} ₮</td>
            </tr>

            <tr v-if="multi">
              <td>Сугалаа:</td>
              <td>{{ taxDetail.tax_lottery }}</td>
            </tr>

          </table>
        </div>
        <div class="tax-wrap-footer">
          <div class="qr-image">
            <vue-qrcode class="desk" width="120" height="120" :value="taxDetail.tax_qr"/>
          </div>
          <div class="number">
            <span>Сугалааны дугаар</span>
            <span>{{ taxDetail.tax_lottery }}</span>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  </Dialog>


  <Dialog v-model:visible="isVisibleQpay" :breakpoints="{'500px': '75vw', '500px': '90vw'}" :style="{width: '440px'}"
          :modal="true">
    <template #header>
      <p class="wallet-modal-header mini" v-if="step == 1" style="color: hsla(0, 0%, 100%, .8)">Кино түрээслэх</p>
      <p v-if="step==2"></p>
    </template>

    <div class="wallet-modal-body"
         style="display: flex; flex-direction: column; align-items: center; justify-content: center;">
      <div v-if="step == 1" style="background: #121212">
        <h5 style="color: hsla(0, 0%, 100%, .8);text-align: center; padding-top: 20px">
          Та банкны апп дээрээс Qpay QR кодыг уншуулж төлбөрөө төлнө үү
        </h5>
        <div v-if="isProceeding" class="qpay-img-loader">
          <ProgressSpinner style="width:50px;height:50px" strokeWidth="3" animationDuration="1000s"/>
        </div>
        <div class="qpay-img-wrap" v-else>
          <img class="qpay-img" v-if="qpayInvoice != null"
               :src="`data:image/png;base64,${qpayInvoice.qr_image}`" alt=""/>
        </div>
      </div>

    </div>

    <template v-if="step == 1" #footer>
      <a v-if="isChecking" href="javascript:void(0)" class="primary-btn full">
        <span>Шалгаж байна...</span>
      </a>

      <a v-else href="javascript:void(0)" @click="checkPayment" class="primary-btn full" style="background: #121212">
        <span>Төлбөр шалгах</span>
      </a>
    </template>
  </Dialog>
</template>

<script>
import Poster from "../../assets/poster.png";
import {imageUrl} from "../../utils";
import {mapActions, mapGetters} from 'vuex';
import DetailsModalSkeleton from "../../skeletons/DetailsModalSkeleton.vue";
import api from "../../store/_boot/baseApi";
import EpisodeList from "../../components/EpisodeList";
import Dialog from "primevue/dialog";
// import ProgressSpinner from "primevue/progressspinner";
import Auth from "../../components/Auth.vue";
import {Radio, RadioGroup} from "view-ui-plus";
import VueQrcode from "vue-qrcode";

export default {
  components: {
    VueQrcode,
    Auth,
    DetailsModalSkeleton,
    EpisodeList,
    Dialog,
    RadioGroup,
    Radio,
    // ProgressSpinner
  },
  data() {
    return {
      Poster,
      isLoading: true,
      isLoadingAccess: true,
      isMainLoadingAccess: true,
      hasAccess: 0,
      isVisibleQpay: false,
      isTaxType: false,
      eBarimtView: false,
      currentSlide: 1,
      step: 1,
      qpayInvoice: null,
      bill: null,
      isProceeding: false,
      isChecking: false,
      resultMsg: '',
      characters: [],

      ebType: "0",
      companyCode: "",
      errorMessage: "",
      taxDetail: null,
      // mainCatId: this.media.main_cat_id
    }
  },

  computed: {
    ...mapGetters(['user', 'media']),
  },

  created() {
    this.isLoading = true;
    this.getMediaDetail({vm: this, mediaID: this.$route.params.id})
    this.mainCheckAccess();
  },

  watch: {
    ebType(newVal) {
      if (newVal === "0") {
        this.companyCode = "";
      }
    },
    media: {
      handler(newVal) {
        console.log("newVal--------->", newVal)
        if (newVal) {
          this.mainCheckAccess();
        }
      },
      immediate: true,
    },
    '$route.params.id': {
      handler: function (val, oldVal) {
        if (oldVal !== val) {
          this.isLoading = true;
          this.getMediaDetail({vm: this, mediaID: val})
          this.mainCheckAccess();
        }
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {
    this.setBackLink(this.$route.fullPath);
    if (this.media) {
      this.mainCheckAccess();
    }
  },

  methods: {
    ...mapActions(['getMediaDetail', 'setBackLink',]),

    next() {
      this.$refs.carousel.next()
    },

    imageUrl,

    prev() {
      this.$refs.carousel.prev()
    },

    getTrailerId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
    },

    mainCheckAccess() {
      if (!this.media || !this.media.main_cat_id) {
        console.error("media эсвэл main_cat_id тодорхойгүй байна.");
        return;
      }
      console.log("this.media.main_cat_id:", this.media.main_cat_id);

      this.isLoadingAccess = true;

      const category = this.media.main_cat_id === 1 ? 'series' : 'anime';
      const userId = this.user?.id ?? null;
// api.get(`/api/m/svod/series/check/${this.user != null ? this.user.id : null}`).then(async ({data}) => {
      api
          .get(`/api/m/svod/${category}/check/${userId}`)
          .then(({data}) => {
            this.hasAccess = data > 0;

            this.isLoadingAccess = false;
          })
          .catch((error) => {
            console.error("Алдаа гарлаа:", error);
            this.isLoadingAccess = false;
          });
    },

    showQpayModal() {
      this.isVisibleQpay = true
      this.createQpayInvoice();
    },
    showTaxType() {
      this.isTaxType = true;
    },
    showEBarimtView() {
      this.eBarimtView = true;
    },

    createQpayInvoice() {
      if (this.isProceeding) {
        return false;
      }

      this.isProceeding = true;
      this.btnTxt = "Түр хүлээнэ үү";
      api.get(`/api/qpay/invoice/${this.user != null ? this.user.id : null}/${this.$route.params.id}/movie`, {
        params: {
          taxType: this.ebType,
          taxReg: this.companyCode,
        }
      }).then(({data}) => {
        if (data.status) {
          this.qpayInvoice = data.data;
          setTimeout(() => {
            this.isProceeding = false;
            this.bill = data.bill;
          }, 1000);
        } else {
          setTimeout(() => {
            this.isProceeding = false;
            this.$Message.error(data.msg);
          }, 1000);
        }
      }).catch(e => {
        console.log(e);
        setTimeout(() => {
          this.isProceeding = false;
          this.$Message.error("Алдаа гарлаа");
          this.btnTxt = "Үргэлжлүүлэх";
        }, 1000);
      })
    },

    checkPayment() {
      this.isChecking = true;
      api.get(`/api/qpay/check/${this.bill}`).then(({data}) => {
        this.isChecking = false;

        if (data.status === 1) {
          this.$toast.success("Төлбөр амжилттай төлөгдлөө!");
          this.gotoFinal();
          this.resultMsg = data.msg;
          this.taxDetail = data.receipt;
          this.mainCheckAccess();
          setTimeout(() => {
            this.isVisibleQpay = false;
          }, 3000);
        } else {
          this.$toast.error("Төлбөр төлөгдөөгүй байна!");
        }
      }).catch(e => {
        console.log(e);
        this.$notify.error({
          title: 'Алдаа гарлаа',
          message: 'Шалгахад алдаа гарлаа'
        });
      })
    },

    gotoFinal() {
      this.step = 2;
      this.paymentType = null;
      this.isVisibleQpay = false;
      this.showEBarimtView();
    },
    // checkAccess() {
    //   this.isLoadingAccess = true;
    //   api.get(`/api/m/tvod/check/${this.user != null ? this.user.id : null}/${this.$route.params.id}`).then(async ({data}) => {
    //     this.hasAccess = data.status;
    //     this.isLoadingAccess = false;
    //   }).catch(() => {
    //     this.isLoadingAccess = false;
    //   })
    // },

    handleInputChange(event) {
      console.log("New Input Value:", event.target.value);
      this.companyCode = event.target.value;
    },
    validateAndNavigate() {
      console.log("ebType ---->", this.ebType);
      console.log("companyCode ---->", this.companyCode);
      if (this.ebType === "1" && (!this.companyCode || !this.companyCode.trim())) {
        this.errorMessage = "Байгууллагын кодоо оруулна уу!";
        return;
      }
      this.errorMessage = "";
      this.isTaxType = false;
      this.showQpayModal();
    }
  }
};
</script>
<style>
.company-code-input {
  border: 1px solid grey !important;
  border-radius: 6px;
  padding: 8px;
  margin-top: 16px;
  width: 100%;
}
</style>
